"use client"

import React from 'react';
import { InvoiceModal } from "./modals/InvoiceModal";
import { SMSModal } from "./modals/SMSModal";
import { NotificationModal } from "./modals/NotificationModal";
import { ExportEInvoiceModal } from "./modals/ExportEInvoiceModal";
import { DeleteButton } from "../../components/table/DeleteButton";
import { useTitleDataStore } from "@/core/stores/title-data.store";
import container from "@/lib/di/container";
import { Suspense, useEffect, useState } from "react";
import { FilterBar, FilterInputTemplate, FilterInputType, handleAddressChange } from "../../components/filter/FilterBar";
import { FilterSearchPayload, DataTable } from "../../components/table/DataTable";
import { Button, Dropdown, message, Modal, Tooltip } from "antd";
import { CheckCircleOutlined, CloseCircleOutlined, ContainerOutlined, HistoryOutlined, InfoCircleOutlined, MailOutlined, MoneyCollectOutlined, MoreOutlined, NotificationOutlined, PayCircleOutlined, PrinterOutlined } from "@ant-design/icons";
import { TollAreaRepo } from "@/core/repos/tables/toll-area.repo";
import { GlobalUtils } from "../../utils/global.utils";
import { WaterInvoiceModel, WaterInvoiceModelFactory } from "@/core/models/water-invoice.model";
import { WaterInvoiceRepo } from "@/core/repos/tables/water-invoice.repo";
import { AddressRepo } from "@/core/repos/address.repo";
import { paymentMethodPipe } from "@/core/pipes/payment-method-pipe";
import { BillingPaymentType, PaymentMethodType, WaterInvoiceApproveStatus, WaterInvoiceStatus } from "@/core/enums/global.enums";
import { UnitTypeRepo } from "@/core/repos/tables/unit-type.repo";
import { cubicMeterPipe } from "@/core/pipes/unit.pipe";
import { formatCurrencyPipe } from "@/core/pipes/format-currency.pipe";
import { formatDateTimePipe } from "@/core/pipes/format-date.pipe";
import { approveStatusPipe } from "@/core/pipes/approve-status.pipe";
import { invoiceStatusPipe, invoiceStatusTagsPipe } from "@/core/pipes/invoice-status.pipe";
import { ContractRepo } from '@/core/repos/tables/contract.repo';
import dayjs from 'dayjs';
import { PaymentWithAccountantModal } from './modals/PaymentWithAccountantModal';
import { useNavigate, useSearchParams } from 'react-router';
import { UserRepo } from '@/core/repos/user.repo';
import { ApproveByTollAreaModal } from './modals/ApproveByTollAreaModal';
import { CreateInvoiceModal } from './modals/CreateInvoiceModal';
import { billingPaymentTypePipe } from '@/core/pipes/billing-payment-type.pipe';
import { PaymentWithAccountantMultiModal } from './modals/PaymentWithAccountantMultiModal';
import AuthRepo from '@/core/repos/auth.repo';
import { PERMISSIONS } from '@/core/enums/permissions.enum';

const waterInvoiceRepo = container.get(WaterInvoiceRepo);
const tollAreaRepo = container.get(TollAreaRepo);
const addressRepo = container.get(AddressRepo);
const unitTypeRepo = container.get(UnitTypeRepo);
const contractRepo = container.get(ContractRepo);
const userRepo = container.get(UserRepo);
const authRepo = container.get(AuthRepo);

function BillingTable() {
    const userDetail = authRepo.useDetails();
    const claims = authRepo.useClaims();
    const [isAccountant, setAccountant] = useState<boolean>();

    const titleData = useTitleDataStore();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const waterUserId = searchParams.get('waterUserId');
    const [modalData, setModalData] = useState<WaterInvoiceModel>(WaterInvoiceModelFactory.getEmpty())
    const [allDataQuery, setAllDataQuery] = useState<any>({})
    const [qrData, setQrData] = useState<string>("")
    const [filterMap, setFilterMap] = useState<Map<string, FilterSearchPayload>>(new Map(
        Object.entries({...waterUserId?{}:GlobalUtils.getPreviousMonthFilter()})
    ))
    const [selectedRows, setSelectedRows] = useState<WaterInvoiceModel[]>([]);
    const [isDetailModal, setDetailModal] = useState(false);
    const [isAddInvoiceModal, setAddInvoiceModal] = useState(false);
    const [isPayWithAccountant, setPayWithAccountant] = useState(false);
    const [isPayWithAccountantMulti, setPayWithAccountantMulti] = useState(false);
    const [isSMSModal, setSMSModal] = useState(false);
    const [isNotificationModal, setNotificationModal] = useState(false);
    const [isExportEInvoiceModal, setExportEinvoiceModal] = useState(false);
    const [isApproveByTollArea, setApproveByTollArea] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [isPrintingInvoices, setPrintingInvoices] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [total, setTotal] = useState(0);
    const [filterTemplates, setFilterTemplates] = useState<FilterInputTemplate[]>([
        {
            dataIndex: "search",
            label: "Tìm kiếm",
            placeholder: "Nhập nội dung tìm kiếm",
            type: FilterInputType.text,
        },
        {
            dataIndex: "month",
            label: "Tháng",
            placeholder: "Chọn tháng",
            type: FilterInputType.month,
        },
        {
            rangeIndex: {from: "DatePaymentFrom", to: "DatePaymentTo"},
            type: FilterInputType.dateRange,
            placeholder: "Thanh toán từ ngày",
            secondaryPlaceholder: "Đến ngày",
            label: "Thời điểm Thanh toán",
            span: 2,
            showTime: true
        },
        {
            dataIndex: "unitTypeId",
            label: "Loại hình",
            placeholder: "Chọn Loại hình",
            type: FilterInputType.select,
            options: []
        },
        {
            dataIndex: "provinceId",
            label: "Tỉnh/ TP",
            placeholder: "Chọn Tỉnh/ TP",
            type: FilterInputType.select,
            options: []
        },
        {
            dataIndex: "districtId",
            label: "Quận/ Huyện",
            placeholder: "Chọn Quận/ Huyện",
            type: FilterInputType.select,
            options: []
        },
        {
            dataIndex: "wardId",
            label: "Xã/ Phường",
            placeholder: "Chọn Xã/ Phường",
            type: FilterInputType.select,
            options: []
        },
        {
            dataIndex: "tollAreaId",
            label: "Khu vực",
            placeholder: "Chọn Khu vực",
            type: FilterInputType.select,
            options: []
        },
        {
            dataIndex: "paymentMethod",
            label: "Hình thức thanh toán",
            placeholder: "Chọn hình thức thanh toán",
            type: FilterInputType.select,
            options: [
                { value: PaymentMethodType.All, name: paymentMethodPipe(PaymentMethodType.All) },
                { value: PaymentMethodType.Bank, name: paymentMethodPipe(PaymentMethodType.Bank) },
                { value: PaymentMethodType.CentralPaid, name: paymentMethodPipe(PaymentMethodType.CentralPaid) },
                { value: PaymentMethodType.HomePay, name: paymentMethodPipe(PaymentMethodType.HomePay) },
                { value: PaymentMethodType.EWallet, name: paymentMethodPipe(PaymentMethodType.EWallet) },
                { value: PaymentMethodType.Manual, name: paymentMethodPipe(PaymentMethodType.Manual) },
                { value: PaymentMethodType.Transfer, name: paymentMethodPipe(PaymentMethodType.Transfer) },
            ]
        },
        {
            dataIndex: "status",
            label: "Tình trạng thanh toán",
            placeholder: "Chọn tình trạng thanh toán",
            type: FilterInputType.select,
            options: Object.keys(WaterInvoiceStatus).map(key => ({ value: key, name: invoiceStatusPipe(key as WaterInvoiceStatus) }))
        },
        {
            dataIndex: "payBillCreator",
            label: "Người thanh toán",
            placeholder: "Chọn Người thanh toán",
            type: FilterInputType.select,
            options: [
                {
                    name: "VNPayQr",
                    value: "VNPayQr"
                },
                {
                    name: "VietinBank",
                    value: "VietinBank"
                }
            ]
        },
        {
            rangeIndex: {from: "InvoiceTimeFrom", to: "InvoiceTimeTo"},
            type: FilterInputType.dateRange,
            placeholder: "Xuất HĐ từ ngày",
            secondaryPlaceholder: "Đến ngày",
            label: "Thời điểm Xuất HĐĐT",
            span: 2,
        },
        {
            dataIndex: "paymentType",
            label: "Loại thanh toán",
            placeholder: "Chọn loại thanh toán",
            type: FilterInputType.select,
            options: [
                { value: BillingPaymentType.Transfer, name: billingPaymentTypePipe(BillingPaymentType.Transfer) },
                { value: BillingPaymentType.Cash, name: billingPaymentTypePipe(BillingPaymentType.Cash) },
                { value: BillingPaymentType.Debtminusdeposit, name: billingPaymentTypePipe(BillingPaymentType.Debtminusdeposit) },
                { value: BillingPaymentType.CollectVNPayQr, name: billingPaymentTypePipe(BillingPaymentType.CollectVNPayQr) },
                { value: BillingPaymentType.CollectEmployee, name: billingPaymentTypePipe(BillingPaymentType.CollectEmployee) },
            ]
        },
        {
            dataIndex: "debtCollector",
            label: "Người gạch nợ",
            placeholder: "Nhập tên người gạch nợ",
            type: FilterInputType.text,
        },
    ])

    const showDetail = async (record: WaterInvoiceModel) => {
        const _qrData = await waterInvoiceRepo.getQR(record);
        setQrData(_qrData);
        setModalData(record);
        setDetailModal(true);
    };

    const showAddInvoice = () => {
        setAddInvoiceModal(true);
    }

    const populateSelections = async () => {
        const tollAreas = (await tollAreaRepo.getAll()).map(r => ({ name: r.name, value: r.id }));
        const provinces = (await addressRepo.getAllProvinces()).map(data => ({ name: data[1].name, value: data[0] }));
        const unitTypes = (await unitTypeRepo.getAll()).map(r => ({ name: r.name, value: r.id }));
        const users = (await userRepo.getFromFactory()).map(r => ({name: `${r.fullName}-${r.userName.toUpperCase()}`, value: r.userName}))
        const templates: FilterInputTemplate[] = [...filterTemplates];
        const tollAreaTemplate = templates.find(template => template.dataIndex === "tollAreaId");
        if (tollAreaTemplate) {
            tollAreaTemplate.options = tollAreas;
        }
        const provinceTemplate = templates.find(template => template.dataIndex === "provinceId");
        if (provinceTemplate) {
            provinceTemplate.options = provinces;
        }
        const unitTypeTemplate = templates.find(template => template.dataIndex === "unitTypeId");
        if (unitTypeTemplate) {
            unitTypeTemplate.options = unitTypes;
        }
        const userTemplate = templates.find(template => template.dataIndex === "payBillCreator");
        if (userTemplate) {
            userTemplate.options = [
                {
                    name: "VNPayQr",
                    value: "VNPayQr"
                },
                {
                    name: "VietinBank",
                    value: "VietinBank"
                },
                ...users
            ];
        }
        setFilterTemplates(templates);
    }

    const init = async () => {
        titleData.setTitleActions({
            text: "Thêm Hoá đơn",
            onPress: () => {
                showAddInvoice();
            },
        });
        await populateSelections();
        if (waterUserId) {
            const contract = await contractRepo.detail(waterUserId);;
            if (contract) {
                titleData.setTitleBack(true);
                titleData.setTitleText(`Hoá đơn - ${contract.code} - ${contract.name}`)
            }
        }
    }

    useEffect(() => {
        init() 
    }, []);


    useEffect(() => {
        if (userDetail?.userName.toLowerCase() === "admin") {
            setAccountant(true);
        } else if (GlobalUtils.checkPerm(claims, "T.KT")) {
            setAccountant(true);
        }
    }, [claims])


    const deleteSelected = async () => {
        setDeleting(true);
        const result = await waterInvoiceRepo.deleteMany(selectedRows);
        messageApi.success({
            content: `Bạn đã xoá thành công ${result.success}/${result.total} bản ghi`
        })
        setDeleting(false);
    }

    async function onFilterChange(map: Map<string, FilterSearchPayload>, changes: string[]) {
        await handleAddressChange(map, changes, filterTemplates, setFilterTemplates);
        setFilterMap(new Map(map));
    }
    const openSMSModal = () => {
        setSMSModal(true);
    }
    const openNotificationModal = () => {
        setNotificationModal(true);
    }
    const openExportEInvoiceModal = () => {
        setExportEinvoiceModal(true);
    }

    const payWithAccountant = (record: WaterInvoiceModel) => {
        setModalData(record);
        setPayWithAccountant(true);
    }

    const openPaymentWithAccountantMultiModal = async () => {
        const defaultParams = {waterUserId};
        let query: any = {};
        filterMap.forEach(filter => {
            if (filter.value) {
                query[filter.key] = filter.value
            }
        })
        if (defaultParams) {
            query = {...query, ...defaultParams, status: WaterInvoiceStatus.Unpaid};
        }
        setAllDataQuery(query);
        setPayWithAccountantMulti(true);
    }

    function onRowSelect(rows: WaterInvoiceModel[]) {
        setSelectedRows([...rows]);
    }

    async function handlePrintInvoices() {
        setPrintingInvoices(true);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const query: any = {};
        message.info("Đang in Hoá đơn, vui lòng đợi giây lát!");
        filterMap.forEach(filter => {
            if (filter.value) {
                query[filter.key] = filter.value
            }
        })  
        const blobData = await waterInvoiceRepo.printInvoices(query);
        if (blobData) {
            GlobalUtils.downloadDOCX(blobData, `Phiếu Thu-Tất cả-${dayjs().format("DDMMYYYY-hhmm")}`)
        };
        setPrintingInvoices(false);
    }

    const createInvoice = async (record: WaterInvoiceModel) => {
        Modal.confirm({
            title: `Xuất hóa đơn điện tử`,
            content: `Xuất hóa đơn điện tử ${record.month}/${record.year} của khách hàng ${record.waterUser?.code} - ${record.waterUser?.name}`,
            okText: "Xuất hóa đơn",
            onOk: async () => {
                const result = await waterInvoiceRepo.exportEInvoice(record.id);
                if (result === true) {
                    message.success("Xuất hóa đơn điện tử thành công!");
                } else if (typeof result === "string") {
                    message.error(result);
                } else {
                    message.error("Xuất hóa đơn thất bại");
                }
            },
        });
    }

    const showLogs = (record: WaterInvoiceModel) => {
        navigate(encodeURI(`/admin/logs?search=${record.id}&objectType=WaterInvoice`));
    };

    const updateApproveStatus = (record: WaterInvoiceModel, status: WaterInvoiceApproveStatus) => {
        const isApprove = status === WaterInvoiceApproveStatus.Approved;
        Modal.confirm({
            title: isApprove ? "Duyệt hoá đơn?" : "Huỷ duyệt hoá đơn?",
            content: `${isApprove ? "Xác nhận duyệt" : "Xác nhận huỷ duyệt"} hoá đơn ${record.month}/${record.year} của khách hàng ${record.waterUser?.code} - ${record.waterUser?.name}?`,
            okText: isApprove ? "Duyệt" : "Huỷ duyệt",
            cancelText: "Đóng",
            okButtonProps: {
                style: {
                    background: isApprove ? "var(--primary-color)" : "var(--danger-color)"
                }
            },
            onOk: async () => {
                const result = await waterInvoiceRepo.approveInvoice({
                    id: record.id,
                    approveStatus: status,
                    paymentDate: record.paymentDate
                });
                if (result === true) {
                    messageApi.success({
                        content: isApprove ? "Duyệt hoá đơn thành công!" : "Huỷ duyệt hoá đơn thành công!"
                    });
                    return;
                }
                messageApi.error({
                    content: typeof result === "string" ? result : (isApprove ? "Duyệt hoá đơn thất bại!" : "Huỷ duyệt hoá đơn thất bại!")
                });
            }
        });
    }

    return (
        <div className="px-4 py-6">

            {contextHolder}
            <FilterBar setMap={setFilterMap} onChange={onFilterChange} templates={filterTemplates} map={filterMap} actions={[
                <div key={1} className="col-span-4">
                    <Button type="primary" loading={isPrintingInvoices} icon={<PrinterOutlined />} style={{ background: "var(--primary-button)" }} onClick={handlePrintInvoices}>In hóa đơn</Button>
                    <Button className='ml-4' type="primary" icon={<ContainerOutlined />} style={{ background: "var(--primary-button)" }} onClick={openExportEInvoiceModal}>Xuất HĐĐT</Button>
                    <Button className='ml-4' type="primary" icon={<NotificationOutlined />} style={{ background: "var(--primary-button)" }} onClick={openNotificationModal} >Gửi thông báo</Button>
                    <Button className='ml-4' type="primary" icon={<MailOutlined />} style={{ background: "var(--primary-button)" }} onClick={openSMSModal}>Gửi SMS</Button>
                    <Button 
                        className='ml-4'
                        type="primary"
                        onClick={() => setApproveByTollArea(true)}
                        icon={<CheckCircleOutlined />}
                        style={{ background: "var(--primary-button)"}}>Duyệt hoá đơn theo khu vực</Button>
                    <Button 
                        className='ml-4'
                        type="primary"
                        onClick={openPaymentWithAccountantMultiModal}
                        icon={<MoneyCollectOutlined />}
                        style={{ background: "var(--primary-button)"}}>Gạch nợ nhiều hoá đơn</Button>
                </div>,
                <div key={1} className="col-span-1">
                    <DeleteButton loading={deleting} noGap length={selectedRows.length} onConfirm={deleteSelected}/>
                </div>,
            ]} />
            <div className="mt-4 border-t border-dashed border-gray-300 pt-6">
                <DataTable<WaterInvoiceModel>
                    columns={[
                        { name: "Tháng", pipe: (value: WaterInvoiceModel) => value.month + "/" + value.year, fixed: "left" },
                        { name: "Số TC", dataIndex: "code" },
                        { name: "HDĐT", dataIndex: "eInvoiceNo" },
                        { name: "Mã HĐ", pipe: (value: WaterInvoiceModel) => value.waterUser?.code ?? "" },
                        { name: "Hình thức thanh toán", pipe: (value: WaterInvoiceModel) => paymentMethodPipe(value.waterUser?.paymentMethod ?? "") },
                        { name: "Tên KH", pipe: (value: WaterInvoiceModel) => value.waterUser?.name ?? "" },
                        { name: "SĐT", pipe: (value: WaterInvoiceModel) => value.waterUser?.phone ?? "" },
                        { name: "CS cuối", dataIndex: "waterMeterNumber", pipe: cubicMeterPipe },
                        { name: "CS đầu", dataIndex: "waterMeterNumberLast", pipe: cubicMeterPipe },
                        { name: "Khối lượng nước", dataIndex: "amount", pipe: cubicMeterPipe },
                        { name: "Tiền thanh toán", dataIndex: "total", pipe: formatCurrencyPipe },
                        { name: "Phê duyệt", dataIndex: "approveStatus", pipe: approveStatusPipe },
                        { name: "Thời gian xuất HĐĐT", dataIndex: "eInvoiceArisingDate", pipe: (e) => formatDateTimePipe(e).length > 0 ? formatDateTimePipe(e) : "Chưa gửi" },
                        { name: "Thời gian gửi", dataIndex: "sendDate", pipe: (e) => formatDateTimePipe(e).length > 0 ? formatDateTimePipe(e) : "Chưa gửi" },
                        { name: "Thời gian TT", dataIndex: "paymentDate", pipe: (e) => formatDateTimePipe(e).length > 0 ? formatDateTimePipe(e) : "" },
                        { name: "Người thanh toán", dataIndex: "payBillCreator" },
                        { name: "Người gạch nợ", dataIndex: "debtCollector" },
                        { name: "TT thanh toán", dataIndex: "status", pipe: invoiceStatusTagsPipe, fixed: "right" },
                        {
                            name: 'Thao tác',
                            render: (_, record) => (
                                <div className="flex flex-row px-1 items-center justify-center">
                                    <Tooltip title="Xem chi tiết"><Button type="text" icon={<InfoCircleOutlined />} onClick={() => showDetail(record)} /></Tooltip>
                                    <Dropdown menu={{items: [
                                            {
                                                key: 'approve',
                                                label: <p>Duyệt hoá đơn</p>,
                                                icon: <CheckCircleOutlined />,
                                                onClick: () => updateApproveStatus(record, WaterInvoiceApproveStatus.Approved),
                                                disabled: record.approveStatus === WaterInvoiceApproveStatus.Approved
                                            },
                                            {
                                                key: 'reject',
                                                label: <p>Huỷ duyệt hoá đơn</p>,
                                                icon: <CloseCircleOutlined />,
                                                onClick: () => updateApproveStatus(record, WaterInvoiceApproveStatus.NotApprove),
                                                disabled: record.approveStatus === WaterInvoiceApproveStatus.NotApprove
                                            },
                                            {
                                                key: '1',
                                                label: <p>Gạch nợ kế toán</p>,
                                                icon: <PayCircleOutlined />,
                                                onClick: () => payWithAccountant(record),
                                                disabled: !isAccountant
                                            },
                                        {
                                                key: '2',
                                                label: <p>Xuất hóa đơn điện tử</p>,
                                                icon: <PayCircleOutlined />,
                                                onClick: () => createInvoice(record)
                                            },
                                        {
                                                key: '3',
                                                label: <p>Xem nhật ký</p>,
                                                icon: <HistoryOutlined />,
                                                onClick: () => showLogs(record),
                                                disabled: !GlobalUtils.checkPerm(claims, PERMISSIONS.AUDITLOG_VIEW.key),
                                            },
                                        ]}} trigger={["hover"]}>
                                            <Button type="text" icon={<MoreOutlined />}/>
                                        </Dropdown>
                                </div>
                            ),
                            fixed: "right",
                        },
                    ]}
                    repository={waterInvoiceRepo}
                    filterMap={filterMap}
                    onSelect={onRowSelect}
                    getTotal={setTotal}
                    defaultParams={{waterUserId}}
                ></DataTable>
            </div>
            {isDetailModal && <InvoiceModal isModalOpen={isDetailModal} setIsModalOpen={setDetailModal} data={modalData} qrData={qrData} /> }
            {isAddInvoiceModal && <CreateInvoiceModal isModalOpen={isAddInvoiceModal} setIsModalOpen={setAddInvoiceModal}/> }
            {isPayWithAccountant &&  <PaymentWithAccountantModal isModalOpen={isPayWithAccountant} setIsModalOpen={setPayWithAccountant} data={modalData} /> }
            {isPayWithAccountantMulti &&  <PaymentWithAccountantMultiModal isModalOpen={isPayWithAccountantMulti} setIsModalOpen={setPayWithAccountantMulti} query={allDataQuery}/> }
            {isSMSModal && <SMSModal isModalOpen={isSMSModal} setIsModalOpen={setSMSModal} data={{ total: total, filterMap }} />}
            {isNotificationModal && <NotificationModal isModalOpen={isNotificationModal} setIsModalOpen={setNotificationModal} data={{ total: total, filterMap }} />}
            {isExportEInvoiceModal && <ExportEInvoiceModal isModalOpen={isExportEInvoiceModal} setIsModalOpen={setExportEinvoiceModal} data={{ total: total, filterMap }}  />}   
            {isApproveByTollArea && <ApproveByTollAreaModal isModalOpen={isApproveByTollArea} setIsModalOpen={setApproveByTollArea} data={{ 
                month: filterMap.get("month")?.value??GlobalUtils.getPreviousMonthFilter().month.value,
                year: filterMap.get("year")?.value??GlobalUtils.getPreviousMonthFilter().year.value,
                tollAreaId: filterMap.get("tollAreaId")?.value
             }}  />}   
        </div>)
}

export default function BillingTablePage() {
    return <Suspense>
        <BillingTable />
    </Suspense>
}